module.exports = __webpack_public_path__ + "static/media/diagonall.0ad89c1a.svg";